var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGastarSaldo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9973 19.9993C14.6844 19.9993 11.9997 22.6848 11.9997 25.9993V53.9993C11.9997 57.3121 14.6879 59.9993 18.0026 59.9993H61.9997C65.3134 59.9993 67.9997 57.313 67.9997 53.9993V52.9993C67.9997 51.8948 68.8951 50.9993 69.9997 50.9993C71.1043 50.9993 71.9997 51.8948 71.9997 52.9993V53.9993C71.9997 59.5222 67.5225 63.9993 61.9997 63.9993H18.0026C12.4807 63.9993 7.99969 59.5231 7.99969 53.9993V25.9993C7.99969 20.4773 12.4737 15.9993 17.9973 15.9993H61.9963C67.518 15.9993 71.9997 20.4754 71.9997 25.9993V28.9993C71.9997 30.1039 71.1043 30.9993 69.9997 30.9993C68.8951 30.9993 67.9997 30.1039 67.9997 28.9993V25.9993C67.9997 22.6867 65.3111 19.9993 61.9963 19.9993H17.9973Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9997 41.97C36.8951 41.97 35.9997 41.0746 35.9997 39.97C35.9997 34.4634 40.4637 29.9993 45.9704 29.9993L58.9997 29.9993C60.1043 29.9993 60.9997 30.8948 60.9997 31.9993C60.9997 33.1039 60.1043 33.9993 58.9997 33.9993L45.9704 33.9993C42.6729 33.9993 39.9997 36.6725 39.9997 39.97C39.9997 41.0746 39.1043 41.97 37.9997 41.97Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9997 36.9993C71.1043 36.9993 71.9997 37.8948 71.9997 38.9993V39.97C71.9997 45.4929 67.5225 49.97 61.9997 49.97H48.9997C47.8951 49.97 46.9997 49.0746 46.9997 47.97C46.9997 46.8655 47.8951 45.97 48.9997 45.97H61.9997C65.3134 45.97 67.9997 43.2837 67.9997 39.97V38.9993C67.9997 37.8948 68.8951 36.9993 69.9997 36.9993Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9997 37.9993C36.8951 37.9993 35.9997 38.8948 35.9997 39.9993C35.9997 45.506 40.4637 49.97 45.9704 49.97H58.9997C60.1043 49.97 60.9997 49.0746 60.9997 47.97C60.9997 46.8655 60.1043 45.97 58.9997 45.97H45.9704C42.6729 45.97 39.9997 43.2969 39.9997 39.9993C39.9997 38.8948 39.1043 37.9993 37.9997 37.9993Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9997 26.9993C71.1043 26.9993 71.9997 27.8948 71.9997 28.9993C71.9997 31.7706 69.7398 33.9993 66.9883 33.9993L56.9997 33.9993C55.8951 33.9993 54.9997 33.1039 54.9997 31.9993C54.9997 30.8948 55.8951 29.9993 56.9997 29.9993L66.9883 29.9993C67.5505 29.9993 67.9997 29.5417 67.9997 28.9993C67.9997 27.8948 68.8951 26.9993 69.9997 26.9993Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGastarSaldo);
export default __webpack_public_path__ + "static/media/iconGastarSaldo.af3743a8a0674514c641af387ee2b49f.svg";
export { ForwardRef as ReactComponent };